import { render, staticRenderFns } from "./AdyenAccountHolderAccounts.vue?vue&type=template&id=3e2fceb0"
import script from "./AdyenAccountHolderAccounts.vue?vue&type=script&lang=js"
export * from "./AdyenAccountHolderAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports